import { loadWorkflows } from '../api/workflows';
import { loadGroups } from '../api/groups';
import { loadWebhooks } from '../api/webhooks';
import { useResourcesStore } from 'vince-core/stores/resourcesStore';
import { Action } from 'vince-core/types/roles';
import { ResourceType, type ResourceItem } from 'vince-core/types/common';

export default defineNuxtPlugin(() => {
    const store = useResourcesStore();
    store.registerResource('WORKFLOW', 'menus.workflows', [Action.WRITE, Action.READ], async () => {
        return await loadWorkflows().then((workflows) => {
            return workflows.map((it) => {
                return {
                    id: it.workflowId!,
                    key: it.workflowId!,
                    label: it.workflowAlias,
                    permissionValue: it.workflowName,
                    permissionLabel: it.workflowAlias || it.workflowName,
                    description: it.description,
                    resourceType: 'WORKFLOW',
                    usable: !it.hasError,
                    labels: it.labels ?? []
                } as ResourceItem;
            });
        });
    }, 'pi pi-workflows', [ResourceType.WORKFLOW]);


    store.registerResource('GROUP', 'foundation.resource.group', [Action.WRITE, Action.READ], async () => {
        const { items } = await loadGroups();
        return items.map(it => ({
            id: it.groupId,
            key: it.groupName,
            label: it.groupAlias || it.groupName,
            resourceType: 'GROUP',
            usable: true
        }));
    }, undefined, [ResourceType.GROUP]);

    store.registerResource('WEBHOOK', 'foundation.resource.webhook', [Action.WRITE, Action.READ], async () => {
        const { items } = await loadWebhooks();
        return items.map(it => ({
            id: it.webhookId,
            key: it.webhookName,
            label: it.webhookName,
            resourceType: 'WEBHOOK',
            usable: true
        }));
    }, undefined, [ResourceType.WEBHOOK]);
});
